export default __webpack_public_path__ + "static/media/dashboard_3.3e31f810.png";